import { render, staticRenderFns } from "./CardStyleVariation.vue?vue&type=template&id=5715bae8&"
import script from "./CardStyleVariation.vue?vue&type=script&lang=js&"
export * from "./CardStyleVariation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports